<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h410_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    label="名称"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      :disabled="eventType==='view'"
                      maxlength="100"
                      show-word-limit
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="所属省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.provinceId"
                      filterable
                      placeholder="请选择省区"
                      style="width:100%"
                      @change="provinceChangeFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="编码"
                    prop="code"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.code"
                      :disabled="eventType==='view'"
                      maxlength="19"
                      show-word-limit
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="规格"
                    prop="specification"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.specification"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="单位"
                    prop="unit"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.unit"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { initInvoiceItemApi, saveOrUpdateInvoiceItemApi } from '@/api/invoiceItem'
import { loadAreaDataApi } from '@/api/area'
export default {
  components: { },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        provinceId: [ { required: true, message: '请选择省区', trigger: 'change' }],
        name: [ { required: true, message: '请输入名称', trigger: 'blur' }],
        code: [ { required: true, message: '请输入编码', trigger: 'blur' },{ min: 19, max: 19, message: '请输入19位的编码', trigger: 'blur' }],
        specification: [ { required: false, message: '请输入规格', trigger: 'blur' }],
        unit: [ { required: false, message: '请输入单位', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入256个字符', trigger: 'blur' } ]
      },
      provinceOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.provinceOptions = []
        this.dialogAddEditViewForm = {
          provinceId: '',
          provinceName: '',
          name: '',
          code: '',
          specification: '',
          unit: '',
          remark: ''
        }
        if(this.eventType === 'add' || this.eventType === 'edit'){
          this.initProvinceSelectData()
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initInvoiceItemApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 初始活动省区下拉数据
    initProvinceSelectData() {
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
        this.loading = false
      })
    },
    // 活动省区下拉回调
    provinceChangeFun(val) {
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '结算单位信息','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateInvoiceItemApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>

</style>
